import { render, staticRenderFns } from "./PanelInfoBox.vue?vue&type=template&id=6bc85b49&scoped=true&"
import script from "./PanelInfoBox.vue?vue&type=script&lang=js&"
export * from "./PanelInfoBox.vue?vue&type=script&lang=js&"
import style0 from "./PanelInfoBox.vue?vue&type=style&index=0&id=6bc85b49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc85b49",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bc85b49')) {
      api.createRecord('6bc85b49', component.options)
    } else {
      api.reload('6bc85b49', component.options)
    }
    module.hot.accept("./PanelInfoBox.vue?vue&type=template&id=6bc85b49&scoped=true&", function () {
      api.rerender('6bc85b49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PanelInfoBox.vue"
export default component.exports